import React from 'react'
import { isValidEmail } from '@ztechapps/common.utils'
import { useFetch } from '@ztechapps/common.hook'
import type { Stringified } from 'type-fest'
import { SubmissionAlert } from './SubmissionAlert'
import { TextInputWithSubmit } from './TextInputWithSubmit'

import { Field } from './Form/Field'
import { Form } from './Form/index'
import { ShowIf } from '@ztechapps/webui.util'
import { useFormikContext } from 'formik'
import { FormStatus } from '@ztechapps/webui.form'

const initialValues = {
  username: '',
}
export type DeleteRequestFormData = typeof initialValues
export type DeleteRequestFormDataErrors = Partial<Stringified<DeleteRequestFormData>>

const validate = (values: DeleteRequestFormData) => {
  const errors: DeleteRequestFormDataErrors = {}

  if (!values.username) {
    errors.username = 'Required'
  } else if (!isValidEmail(values.username)) {
    errors.username = 'Invalid email format.'
  }

  return errors
}

export const DeleteRequestForm = () => {
  const [onSend, { error }] = useFetch('/api/account-deletion/')

  const onSubmit = async (data: DeleteRequestFormData) => {
    await onSend(data)
  }

  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={onSubmit}>
      <DeleteRequestFormField />
      <div className="my-3">
        <SubmissionAlert error={error} />
      </div>
    </Form>
  )
}

export const DeleteRequestFormField = () => {
  const { status } = useFormikContext()

  return (
    <ShowIf condition={status !== FormStatus.success}>
      <p>
        To start the process, please provide us the username/email that you use to login to our TotalMilk apps (e.g.{' '}
        <a href="/hauler">TotalMilk Hauler</a>, <a href="/principal">TotalMilk Principal</a>)
      </p>

      <Field name="username" component={TextInputWithSubmit} />
    </ShowIf>
  )
}
